export const Role = {
    ADMIN: 'ADMIN',
    CUSTOMER: 'CUSTOMER',
    CLIENT: 'CLIENT',
    REFERRAL_PARTNER: 'REFERRAL PARTNER',
    SERVICE_DELIVERY_PARTNER: 'SERVICE DELIVERY PARTNER',
} as const;

export const isPartner = (role: string) => {
    if (!role) {return false;}
    const normalized = role.toUpperCase();
    return normalized.includes('PARTNER');
};

export const isAdmin = (role: string) => {
    return role?.toUpperCase() === Role.ADMIN;
};

export const isCustomer = (role: string) => {
    return role?.toUpperCase() === Role.CUSTOMER;
};

export const isClient = (role: string) => {
    return role?.toUpperCase() === Role.CLIENT;
};
